import { AddressTypes, ECategoryOfWarehouse } from '@models';
import { InternetOrder } from '../../models/internet-order.model';

export const ADDRESS_TYPE_BY_WAREHOUSE_CATEGORY: Record<ECategoryOfWarehouse, AddressTypes> = {
  [ECategoryOfWarehouse.Warehouse]: AddressTypes.WAREHOUSE,
  [ECategoryOfWarehouse.Branch]: AddressTypes.WAREHOUSE,
  [ECategoryOfWarehouse.DropOff]: AddressTypes.WAREHOUSE,
  [ECategoryOfWarehouse.Store]: AddressTypes.STORE,
  [ECategoryOfWarehouse.Postomat]: AddressTypes.POSTBOX,
};

/** Maps a warehouse category from the `getWarehouses` API to the address-type radio value. */
export function getAddressTypeByWarehouseCategory(category: ECategoryOfWarehouse): AddressTypes {
  return ADDRESS_TYPE_BY_WAREHOUSE_CATEGORY[category] ?? AddressTypes.WAREHOUSE;
}

/**
 * Marketplaces may omit the structured recipient city name (`city_name` is optional
 * in Prom's delivery provider data); in that case falls back to the city segment
 * of the free-text delivery address, e.g. "м. Київ (Київська обл.), <rest>".
 */
export function getOrderRecipientCityName(order: InternetOrder): string {
  return order.recipientCityName || order.recipientAddress?.id?.split(', ')[0] || '';
}

/** Matches the postbox number in a free-text delivery address, e.g. "Поштомат №56097"
 * ("почтомат" in the russian spelling).
 */
export const POSTBOX_NUMBER_PATTERN = /(?:пошт|почт)омат\s*№?\s*(\d+)/i;

/**
 * Extracts the postbox number from the order's free-text delivery address, e.g.
 * "смт. Кринички (...), Поштомат №56097: вул. Центральна, 11" -> "56097".
 * Returns null when the address is not a postbox.
 */
export function getOrderPostboxNumber(order: InternetOrder): string | null {
  return order.recipientAddress?.id?.match(POSTBOX_NUMBER_PATTERN)?.[1] ?? null;
}

/** An order with a street name is delivered to a doors address rather than a pickup point. */
export function isOrderDeliveryToDoors(order: InternetOrder): boolean {
  return !!order.recipientStreetName;
}
